import { http, ep } from '../../client/http';

export const blogRepo = {
  get: async () => {
    const res = await http.get(ep('blog/list'), {
      params: { status: true }
    });
    return res.data.data;
  }
};
